"use client";

import { useState } from "react";
import { T } from "@/lib/i18n/T";

const POSITIONS: Record<string, { titleId: string; list: string[] }> = {
  corporate: { titleId: "careers.tabs.corporate", list: [] },
  retail: { titleId: "careers.tabs.retail", list: [] },
  logistics: { titleId: "careers.tabs.logistics", list: [] },
};

export function OpenPositions() {
  const [current, setCurrent] = useState("corporate");
  const active = POSITIONS[current];

  return (
    <section className="rb-careers-open csx3-R11">
      <div className="rb-careers-open-inner csx3-C00">
        <div className="rb-careers-open-title csx3-C00">
          <h3><T id="careers.open.title" /></h3>
          <div className="rb-careers-tabs csx3-R01">
            {Object.entries(POSITIONS).map(([key, p]) => (
              <button
                key={key}
                className={`rb-careers-tab ${current === key ? "active" : ""}`}
                onClick={() => setCurrent(key)}
              >
                <h4><T id={p.titleId} /></h4>
              </button>
            ))}
          </div>
        </div>
        <div className="rb-careers-list">
          {active.list.length === 0 && (
            <div className="rb-careers-none csx3-C11">
              <p>
                <T id="careers.open.none" />
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
